// extracted by mini-css-extract-plugin
export default {"returnLink":"styles__returnLink__d6d643d7bb05f414cbbf"};